const MathHelpers = {};

// Constants
MathHelpers.DEG2RAD = Math.PI / 180;
MathHelpers.RAD2DEG = 180 / Math.PI;

// Calculates a vertical FOV from a fixed horizontal FOV and aspect ratio.
// By default, THREE.PerspectiveCamera works by specifying a fixed vertical FOV and aspect ratio.
// Once we get to a slim enough aspect ratio, we want to specify a fixed horizontal FOV instead.
MathHelpers.horizontalToVerticalFOV = function horizontalToVerticalFOV(horizontalFOV, aspectRatio) {
    return Math.atan(Math.tan(horizontalFOV * MathHelpers.DEG2RAD / 2) / aspectRatio) * MathHelpers.RAD2DEG * 2;
}

export default MathHelpers;